import type { ErrorMessage } from "src/types/ErrorMessage"
import { isUiErrorResponse } from "../isUIErrorResponse/isUIErrorResponse"

export const extractErrorMessage = (error: unknown): ErrorMessage => {
	return isUiErrorResponse(error)
		? {
				message: error.response.data.message,
				traceId: error.response.data.traceId,
			}
		: {
				message: (error as any)?.response?.data?.message,
			}
}
